<template>
  <div class="cont-box">
    <img src="../assets/c-bg-top.png">
    <img src="../assets/c-bg-bottom.png" class="img01">
    <div class="cont">
      <div class="header">
        <img class="logo" src="../assets/c-logo.png">
        <img class="title" src="../assets/c-title.png">
        <p class="title-d">【受理员工、供应商、客户投诉】</p>
      </div>
      <el-form label-position="top" label-width="80px" :rules="rules" ref="subData" :model="subData">
        <el-form-item label="主题:" prop="subject">
          <el-input type="textarea" v-model="subData.subject" placeholder="请描述你的主题"></el-input>
        </el-form-item>
        <el-form-item label="被诉人信息:" prop="involve">
          <el-input v-model="subData.involve" placeholder="格式: 公司-姓名-工号 / 供应商 / 客户"></el-input>
        </el-form-item>
        <el-form-item label="投诉内容:" prop="complaint">
          <el-input type="textarea" rows="4" v-model="subData.complaint" placeholder="请描述你问题和意见(尽量详细并附证)"></el-input>
        </el-form-item>
        <el-form-item label="附件上传:" prop="path">
          <el-upload :action="axios.defaults.baseURL+'/fleUploadAndDownload/FileUpload'" v-model="subData.path"
                     :file-list="fileList" :auto-upload="true" :limit="1" ref="upload" :on-exceed="handleExceed" :before-upload="handleBeforeUpload"
                     :on-remove="handleRemove" :on-success="handleSuccess" :on-error="handleError" class="my-upload">
            <el-button type="infor" v-model="subData.path">上传附件</el-button>
            <div style="line-height: 1.4;" slot="tip" class="el-upload__tip">附件大小不超过20MB，若文件过大或上传失败，可将证据发送至 <strong style="color: #323232;">lianjie@csg.com.cn</strong> 邮箱</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="投诉方式:" prop="type">
          <el-checkbox  v-model="subData.type">匿名</el-checkbox >
        </el-form-item>
        <template v-if="!subData.type">
          <el-form-item label="您的信息及联系方式:" prop="name">
            <el-input v-model="subData.name" placeholder="姓名"></el-input>
          </el-form-item>
          <el-form-item prop="companyOrDepartment">
            <el-input v-model="subData.companyOrDepartment" placeholder="格式: 公司-姓名-工号 / 供应商 / 客户"></el-input>
          </el-form-item>
        </template>
        <el-form-item :label="subData.type ? '您的联系方式:':''" prop="contact">
          <el-input v-model="subData.contact" placeholder="手机号" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item prop="mailBox">
          <el-input v-model="subData.mailBox" placeholder="邮箱"></el-input>
          <p v-if="subData.type" style="color: #646464; font-size: .8em; line-height: 1.2; padding-top: 8px;">感谢您的反馈，请留下您的联系方式，后续将有专人与您对接沟通。</p>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('subData')" class="sub-btn">提&nbsp;&nbsp;交</el-button>
        </el-form-item>
      </el-form>
      <div class="der">
        <p><span>投诉要求说明：</span></p>
        <ul class="list">
          <li><span>1.</span><p>受理范围：公司员工、客户、供应商违反公司管规、合同约定、集团廉洁、利益冲突等违规舞弊事项；</p></li>
          <li><span>2.</span><p>若您反馈的事项未在受理范围内，将转由相关部门处理；</p></li>
          <li><span>3.</span><p>严禁虚假投诉、恶意诽谤，一经查实从严处理。</p></li>
        </ul>
      </div>
    </div>
    <div class="pop" v-if="pop">
      <div class="pop-cont">
        <p>投诉须知</p>
        <p>禁止恶意诽谤，个人信息公司严格保密</p>
        <p>(受理对象员工、供应商、客户)</p>
        <el-button type="primary" class="pop-btn" @click="pop = false">确认</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    data() {
      // var validateContact = (rule, value, callback) => {
      //   if(this.subData.type) {
      //     if(value === '' && !this.subData.mailBox) {
      //       if (!/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(value)) {
      //         callback(new Error('请输入正确的手机号'));
      //       }
      //     } else {
      //       callback();
      //     }
      //   } else {
      //     if(value === '') {
      //       if (!/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(value)) {
      //         callback(new Error('请输入正确的手机号'));
      //       }
      //     } else {
      //       callback();
      //     }
      //   }
      // }
      // var validateMailBox = (rule, value, callback) => {
      //   if(this.subData.type) {
      //     if(value === '' && !this.subData.contact) {
      //       if (!/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/ .test(value)) {
      //         callback(new Error('请输入正确的邮箱'));
      //       }
      //     } else {
      //       callback();
      //     }
      //   } else {
      //     if(value === '') {
      //       if (!/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/ .test(value)) {
      //         callback(new Error('请输入正确的邮箱'));
      //       }
      //     } else {
      //       callback();
      //     }
      //   }
      // }
      return {
        axios: axios,
        pop: true,
        fileList: [],
        subData: {
          subject: '',
          involve: '',
          complaint: '',
          path: '',
          type: false,
          name: '',
          contact: '',
          companyOrDepartment: '',
          mailBox: ''
        },
        rules: {
          subject: [{
            required: true,
            message: '请填写',
            trigger: 'blur'
          }],
          involve: [{
            required: true,
            message: '请填写',
            trigger: 'blur'
          }],
          complaint: [{
            required: true,
            message: '请填写',
            trigger: 'blur'
          }],
          name: [{
            required: true,
            message: '请填写',
            trigger: 'blur'
          }],
          // contact: [{
          //   validator: validateContact,
          //   trigger: "blur"
          // }],
          // mailBox: [{
          //   validator: validateMailBox,
          //   trigger: "blur"
          // }],
          /*
          contact: [{
            required: true,
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }],
          mailBox: [{
            required: true,
            pattern: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/ ,
            message: "请输入正确的邮箱",
            trigger: "blur"
          }],
          */
          companyOrDepartment: [{
            required: true,
            message: '请填写',
            trigger: 'blur'
          }],
        }
      }
    },
    mounted() {

    },
    methods: {
      handleBeforeUpload(file) {
        // const isJPG = file.type === "image/jpg"
        // const isPng = file.type==="image/png"
        // const isJpeg=file.type==="image/jpeg"
        //1MB=1024*1024(1MB=1024KB 1KB=1024MB)
        const is20M = file.size / 1024 / 1024 < 20;
        //限制文件上传类型
        // if (!isJPG && !isPng && !isJpeg) {
        //   this.$message.error("上传图片只能是 png,jpg,jpeg 格式!")
        //   return false
        // }
        //限制文件上传大小
        if (!is20M) {
          this.$message.error("附件大小不超过20MB!")
          return false
        }
        return true
      },
      handleExceed(files, fileList) {
        this.$message({
          message: '超出最大上传数',
          type: 'warning',
          center: true,
          customClass: 'my-mes',
          duration: 1000
        })
      },
      handleRemove(file) {
        this.$refs.upload.clearFiles()
        this.subData.path = ''
      },
      handleSuccess(res, file) {
        this.subData.path = res.data
      },
      handleError(res, file) {
        this.$message.error("上传失败，请稍后重试。")
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$axios.post('/complaints-suggestions/save', this.subData).then(res => {
              this.$refs[formName].resetFields()
              this.$refs.upload.clearFiles()
              this.$alert('提交成功，将有工作人员处理！', '', {
                confirmButtonText: '确定',
                customClass: 'my-alert',
                center: true,
                callback: action => {}
              })
            })
          } else {
            console.log('error submit!!');
            return false
          }
        })
      }
    }
  }
</script>

<style scoped>
  .cont-box {
    position: relative;
    /* height: 100%; */
  }

  .cont-box>img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: -1;
  }

  .el-checkbox {
    z-index: 0;
  }

  .cont-box>img.img01 {
    bottom: 0;
    top: auto;
  }

  .el-form {
    padding: 0 2rem;
  }

  .header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    align-items: center;
  }

  .logo {
    width: 40%;
    padding: 2rem 0 1rem;
  }

  .title {
    width: 60%;
  }

  .title-d {
    color: #e8380d;
    padding: 0.8rem 0;
  }

  .el-form--label-top>>>.el-form-item__label {
    padding: 0;
    font-weight: bold;
  }

  .el-button {
    width: 100%;
  }

  .el-button.sub-btn {
    margin: 1rem 0 2rem;
    background-color: #e8320d;
    border: none;
    font-size: 1.2rem;
    font-weight: bold;
    padding: 1rem 0;
  }

  .el-button.pop-btn {
    width: 6rem;
    background-color: #e8320d;
    border: none;
    margin: 1rem 0 .5rem;
  }

  .pop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .6);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .pop-cont {
    box-sizing: border-box;
    width: 72%;
    height: 16rem;
    background: white;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 0 1rem;
  }

  .pop-cont>p:nth-of-type(1) {
    font-size: 1.2rem;
    font-weight: bold;
    margin: .5rem 0 1rem;
  }

  .pop-cont>p:nth-of-type(2) {
    color: #e8320d;
    font-size: 1.1rem;
    text-align: center;
    margin-bottom: .5rem;
  }

  .pop-cont>p:nth-of-type(3) {
    color: #646464;
    text-align: center;
    line-height: 2rem;
  }

  .der {
    padding: 0 2rem 3rem;
  }

  .der>p {
    line-height: 2rem;
    color: #e8320d;
  }

  .der>p>span:nth-of-type(1) {
    font-weight: bold;
  }

  .list > li{
    font-size: .9rem;
    display: flex;
    color: #323232;
    margin-bottom: 6px;
  }

  .list > li > span {
    padding-right: 5px;
  }

  .my-upload>>>.el-upload {
    width: 100%;
  }

  .el-input >>> .el-input__inner, .el-textarea >>> .el-textarea__inner {
    color: #323232;
  }
</style>
